import { EC_TYPE_CED, EC_TYPE_EXT, EC_TYPE_RUC } from '../constants';

/**
 * Possible ID types in Ecuador E-Commerce
 */
const idTypesHelper = [
    {
        type: EC_TYPE_CED,
        check: (state) => {
            const cedula = state.id.trim();

            if (cedula.length !== 10) {
                return false; // La cédula debe tener exactamente 10 dígitos
            }

            const digitoVerificador = parseInt(cedula.charAt(9), 10);
            let suma = 0;

            for (let i = 0; i < 9; i++) {
                let multiplicador = i % 2 === 0 ? 2 : 1;
                let valor = parseInt(cedula.charAt(i), 10) * multiplicador;

                if (valor > 9) {
                    valor -= 9;
                }

                suma += valor;
            }

            let modulo = suma % 10;
            let resultado = modulo === 0 ? 0 : 10 - modulo;

            if (resultado === digitoVerificador) {
                state.personType = 'N';
                state.isForeigner = false;
                return true;
            }
        },
    },
    {
        //Persona Natural
        type: EC_TYPE_RUC,
        check: (state) => {
            const ruc = state.id.trim();

            if (ruc.length !== 13) {
                return false; // El RUC de persona natural debe tener exactamente 13 dígitos
            }

            const digitoVerificador = parseInt(ruc.charAt(9), 10);
            let coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
            let suma = 0;

            for (let i = 0; i < 9; i++) {
                let valor = parseInt(ruc.charAt(i), 10) * coeficientes[i];

                if (valor >= 10) {
                    valor -= 9;
                }

                suma += valor;
            }

            let modulo = suma % 10;
            let resultado = modulo === 0 ? 0 : 10 - modulo;

            if (resultado === digitoVerificador) {
                state.personType = 'N';
                state.isForeigner = false;
                return true;
            }
        },
    },
    {
        // Persona Jurídica (public or private)
        type: EC_TYPE_RUC,
        check: (state) => {
            const ruc = state.id.trim();

            if (ruc.length !== 13) return false;

            const thirdDigit = parseInt(ruc.charAt(2), 10);
            const digitoVerificador = parseInt(ruc.charAt(8), 10);

            if (thirdDigit === 6) {
                // Public sector
                const coeficientes = [3, 2, 7, 6, 5, 4, 3, 2];
                let suma = 0;

                for (let i = 0; i < 8; i++) {
                    suma += parseInt(ruc.charAt(i), 10) * coeficientes[i];
                }

                let modulo = suma % 11;
                let resultado = modulo === 0 ? 0 : 11 - modulo;

                if (resultado === digitoVerificador) {
                    state.personType = 'J';
                    state.isForeigner = false;
                    return true;
                }
            } else if (thirdDigit === 9) {
                // Private company
                const coeficientes = [4, 3, 2, 7, 6, 5, 4, 3, 2];
                let suma = 0;

                for (let i = 0; i < 9; i++) {
                    suma += parseInt(ruc.charAt(i), 10) * coeficientes[i];
                }

                let modulo = suma % 11;
                let resultado = modulo === 0 ? 0 : 11 - modulo;

                if (resultado === parseInt(ruc.charAt(9), 10)) {
                    state.personType = 'J';
                    state.isForeigner = false;
                    return true;
                }
            }

            return false;
        },
    },
    {
        type: EC_TYPE_EXT,
        check: (state) => {
            if (state.id.trim().length > 6 && state.isForeigner) {
                state.personType = 'NF';
                return true;
            }
        },
    },
];

export const determineIdType = (state) => {
    for (const idType of idTypesHelper) {
        if (idType.check(state)) {
            return idType.type;
        }
    }
    return null;
};
